import React from 'react';

const Skeleton = ({ variant = 'text', width, height, className = '', style }) => {
  const variants = {
    text: { height: '16px', width: width || '100%', borderRadius: '4px' },
    title: { height: '32px', width: width || '75%', borderRadius: '6px' },
    avatar: { height: '48px', width: '48px', borderRadius: '50%' },
    button: { height: '40px', width: width || '96px', borderRadius: '8px' },
    card: { height: height || '192px', width: width || '100%', borderRadius: '12px' },
    circle: { height: height || '48px', width: height || '48px', borderRadius: '50%' }
  };

  const variantStyle = variants[variant] || variants.text;

  return (
    <div
      className={className}
      style={{
        ...variantStyle,
        background: 'linear-gradient(90deg, #1f2937 0%, #374151 50%, #1f2937 100%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 1.5s ease-in-out infinite',
        ...style
      }}
    />
  );
};

export const SkeletonGroup = ({ count = 3, variant = 'text', gap = '12px', ...props }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap }}>
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} variant={variant} {...props} />
      ))}
    </div>
  );
};

export default Skeleton;
